import { z } from 'zod'

export const PaginationSchema = z.object({
  limit: z.number().int().optional(),
  page: z.number().int().optional(),
  start_date: z.string().optional(),
  end_date: z.string().optional(),
  status: z.number().int().optional(),
})

export function NewZodError(message) {
  const e = new Error(message)
  Object.assign(e, { response: { data: { error: message } } })
  return e
}

export function Validate(schema, data) {
  const result = schema.safeParse(data)

  if (!result.success) {
    console.error(result.error)
    throw NewZodError('Erro na validação do Schema', result.error)
  }

  return result.data
}
